import AppRouter from './routes/AppRouter';
/* ⓘ LES MÉTA-DONNÉES SUIVENT LA NAVIGATION — lot visibilité, 14/10/2026.
 *   Monté ICI, au-dessus du routeur, pour une raison : il doit voir CHAQUE
 *   changement de route, y compris celles qui sortent de la vitrine (où il
 *   remet le titre du site). Placé dans une page, il ne verrait que la sienne. */
import Seo from './seo/Seo';

function App() {
  return (
    <>
      <Seo />
      <AppRouter />
    </>
  );
}

export default App;
